/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntegrationEventResponse } from './IntegrationEventResponse';
import {
    IntegrationEventResponseFromJSON,
    IntegrationEventResponseFromJSONTyped,
    IntegrationEventResponseToJSON,
    IntegrationEventResponseToJSONTyped,
} from './IntegrationEventResponse';

/**
 * 
 * @export
 * @interface FindAllIntegrationEventsByFacilityId200Response
 */
export interface FindAllIntegrationEventsByFacilityId200Response {
    /**
     * 
     */
    data?: IntegrationEventResponse;
}

/**
 * Check if a given object implements the FindAllIntegrationEventsByFacilityId200Response interface.
 */
export function instanceOfFindAllIntegrationEventsByFacilityId200Response(value: object): value is FindAllIntegrationEventsByFacilityId200Response {
    return true;
}

export function FindAllIntegrationEventsByFacilityId200ResponseFromJSON(json: any): FindAllIntegrationEventsByFacilityId200Response {
    return FindAllIntegrationEventsByFacilityId200ResponseFromJSONTyped(json, false);
}

export function FindAllIntegrationEventsByFacilityId200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllIntegrationEventsByFacilityId200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : IntegrationEventResponseFromJSON(json['data']),
    };
}

export function FindAllIntegrationEventsByFacilityId200ResponseToJSON(json: any): FindAllIntegrationEventsByFacilityId200Response {
    return FindAllIntegrationEventsByFacilityId200ResponseToJSONTyped(json, false);
}

export function FindAllIntegrationEventsByFacilityId200ResponseToJSONTyped(value?: FindAllIntegrationEventsByFacilityId200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': IntegrationEventResponseToJSON(value['data']),
    };
}

